var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Daftar Asset","sidebar":true}},[_c('Sidebar',{attrs:{"value":_vm.asset,"rebind":_vm.rebind},on:{"update:value":function($event){_vm.asset=$event},"add-asset":_vm.AddAsset}}),_c('aset-gedung',{attrs:{"forms":_vm.forms},on:{"save":_vm.Save}}),_c('aset-jalan',{attrs:{"forms":_vm.forms},on:{"save":_vm.Save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }